<template>
  <div class="internalTrainingList">
    <heads></heads>
    <div class="container" ref="containerRef">
      <div
        class="container-top"
        ref="containerTopRef"
        :style="{ '--background': 'url(' +'\''+ bannerArray.path +'\''+ ')' }"
      ></div>
      <div class="container-bottom">
        <div class="training-list" ref="trainingListRef">
          <div class="training-list-sort" ref="trainingListSortRef">
            <ul>
              <li class="select">默认排序</li>
              <li @click="showCatagory()">{{ selectType }}</li>
            </ul>
            <div class="catagory" v-if="isShowCatagory">
              <div style="font-weight: 700" @click="selectCatagory()">全部</div>
              <div
                @click="selectCatagory(item)"
                v-for="item in typeList"
                :key="item.id"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="training-list-content">
            <div
              class="training-list-content-item"
              @click="toDetail(item.id)"
              v-for="(item, idnex) in pageArray"
              :key="idnex"
            >
              <div class="training-list-left">
                <img :src="item.image" />
                <p>{{ item.internalTrainingTypeName }}</p>
              </div>
              <div class="training-list-middle">
                <div class="title">
                  {{ item.title }}
                </div>
                <div class="types">
                  课程分类：{{ item.internalTrainingTypeName }}
                </div>
                <div class="flex-row">
                  <div class="duration">
                    课程时长：{{ item.courseTime ? item.courseTime : "-" }}
                  </div>
                  <div class="method">
                    授课方式：{{ getCourseWay(item.courseWay) }}
                  </div>
                </div>
                <div class="crowds">
                  适用人群：{{ item.fitPeople ? item.fitPeople : "-" }}
                </div>
              </div>
              <div class="training-list-right">
                <div class="detail">查看详情</div>
              </div>
            </div>
            <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageNum"
                :page-size="pageSize"
                :total="total"
              ></el-pagination>
            </div>
          </div>
        </div>
        <!--定制方案区-->
        <div
          class="free-booking"
          ref="freeBookingRef"
          :class="freeBookingStyle == 1 ? 'free-booking-1' : 'free-booking-2'"
          :style="freeBookingStyle == 2 ? { top: topHeight } : ''"
        >
          <div class="free-booking-header">
            <span class="free-booking-dot"></span>
            <span class="free-booking-title">定制咨询服务</span>
            <span class="free-booking-dot"></span>
          </div>
          <div class="free-booking-item free-booking-item2">
            <span class="txt">联系人</span>
            <el-input
              v-model="form.contact"
              placeholder="联系人"
              style="display: inline"
            ></el-input>
          </div>
          <div class="free-booking-item free-booking-item2">
            <span class="txt request">联系电话</span>
            <el-input
              v-model="form.mobile"
              placeholder="联系电话"
              style="display: inline"
            ></el-input>
          </div>
          <div class="free-booking-item">
            <span class="txt request">验证码</span>
            <div class="sendCode">
              <el-input
                v-model="form.verificationCode"
                placeholder="4位验证码"
                style="display: inline"
              ></el-input>
              <span
                class="txt2"
                :class="isPhoneNumber(form.mobile) ? 'active-txt2' : ''"
                @click="sendSMS"
                >{{ smsCodeTime != 0 ? smsCodeTime : "短信验证" }}</span
              >
            </div>
          </div>
          <div class="element-row">
            <div class="free-booking-item">
              <div
                class="
                  tool-button
                  free-booking-item-order-submit
                  tool-button-primary
                "
              >
                <button @click="submit">提交需求</button>
              </div>
            </div>
          </div>
        </div>
        <!-- 定制方案区 -->
      </div>
    </div>
    <homeFoots></homeFoots>
    <homeBottomImage style="z-index:1000"></homeBottomImage>
    <quickContact :message="quickContactMessage"></quickContact>
  </div>
</template>
<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import { handlePicPlusPre, isPhoneNumber } from "@/util/util.js";
import homeBottomImage from "@/components/comment/homeBottomImage.vue";
import axios from "axios";
import wxShare from "@/common/wx_share.js";
export default {
  name: "internalTrainingList",
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      nav: 0,
      id: 0,
      pageArray: [],
      bannerArray: [
        { path: "https://www.gg.com/images/cases-banner1.jpg" },
      ],
      typeList: [],
      loading: false,
      selectType: "课程分类",
      typeId: null,
      //
      testList: [1, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10],
      freeBookingStyle: 2,
      topHeight: "0px",

      isShowCatagory: false,
      // 提交表单
      form: {
        contact: null,
        mobile: "",
        verificationCode: "",
      },
      // 短信倒计时
      smsCodeTime: 0,
      // -- 免费定制
      quickContactMessage: {
        type: 1,
      },
    };
  },
  components: {
    heads,
    homeFoots,
    quickContact,
    homeBottomImage
  },
  computed: {
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity
        ? this.$store.state.locationSiteCity
        : 5;
    },
  },
  methods: {
    isPhoneNumber,
    handlePicPlusPre,
    
    // 获取广告
    getBanner() {
      const params = {
        positionId: 15,
        cityId: this.getLocationSiteCityId,
      };
      axios
        .get(`/api/adm/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
          if (res.data && res.data.code == 200) {
            if (res.data.adList) {
              this.bannerArray = res.data.adList;
              if (this.bannerArray && this.bannerArray.length>0) {
                this.bannerArray.forEach((banner) => {
                  if (banner.path) {
                    banner.path = this.handlePicPlusPre(banner.path);
                  } else {
                    banner.path = "ak.jpg";
                  }
                  banner.path = banner.path[0];
                });
                console.log(this.bannerArray)
                this.bannerArray = this.bannerArray[0];
              }else{
                this.bannerArray.path = "ak.jpg";
              }
              console.log(this.bannerArray)
            }
          }
        });
    },
    // 线下，线上方式
    getCourseWay(courseWay) {
      let courseWayDecription = "";
      if (courseWay == 1) {
        courseWayDecription = "线下";
      } else if (courseWay == 2) {
        courseWayDecription = "线上";
      } else {
        courseWayDecription = "";
      }
      return courseWayDecription;
    },
    // fomateDate,
    showCatagory() {
      this.isShowCatagory = true;
    },
    selectCatagory(item) {
      let isQuery = true;
      if (item) {
        if (this.typeId != item.id) {
          this.typeId = item.id;
          this.selectType = item.name;
        } else {
          isQuery = false;
        }
      } else {
        if (this.typeId != null) {
          this.typeId = null;
          this.selectType = "课程分类";
        } else {
          isQuery = false;
        }
      }
      this.isShowCatagory = false;
      if (isQuery) {
        this.pageNum = 1;
        this.getInternalTraininList();
      }
    },
    toDetail(id) {
      window.open("/#/internalTrainingDetail?id=" + id);
    },
    // 获取内训列表
    // -- 分页方法
    handleCurrentChange(val) {
      this.loading = true;
      this.getInternalTraininList();
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    getInternalTraininTypeList() {
      axios.get(`/api/internalTraining/typeList`, {}).then((res) => {
        console.log(res);
        if (res.data && res.data.code == 200) {
          this.typeList = res.data.data;
          // console.log("this.typeList");
          // console.log(this.typeList);
        }
      });
    },
    clearForm() {
      // 提交表单
      this.form = {
        // peopleNumber: null,
        // avgPrice: null,
        // activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        // wxNo: null,
        // description: null,
      };
    },
    getInternalTraininList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        typeId: this.typeId,
      };
      axios
        .get(`/api/internalTraining/indexList`, {
          params,
        })
        .then((res) => {
          // console.log(res);
          this.loading = false;
          if (res.data && res.data.code == 200) {
            this.total = res.data.total;
            this.pageArray = res.data.rows;
            if (this.pageArray) {
              this.pageArray.forEach((pageItem) => {
                // console.log(pageItem);
                if (pageItem.image) {
                  pageItem.image = handlePicPlusPre(pageItem.image);
                  pageItem.image = pageItem.image[0];
                }
              });
            }
          }
        });
    },
    // 发送短信
    sendSMS() {
      if (this.smsCodeTime > 0 || !isPhoneNumber(this.form.mobile)) {
        return;
      }
      let params = { mobile: this.form.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 短信计时器
    smsDown() {
      setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
      }, 1000);
    },
    // 提交表单
    submit() {
      let { mobile, verificationCode } = this.form;
      // console.log(!mobile || mobile.length != 11);
      // console.log(!verificationCode);
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      this.form.type = "3";
      let params = this.form;
      axios
        .post(`/api/requirement/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          // console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
              if (res.data.msg) {
                msg = res.data.msg;
              } else {
                msg = "需求提交成功";
              }
              this.$message({
                message: msg,
                type: "success",
                center: true,
              });
              this.clearForm();
            } else {
              if (res.data.code == 500) {
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 计算免费定制的显示
    handleScrollx() {
      let contentTopBottom =
        this.$refs.containerTopRef.getBoundingClientRect().bottom;
      // let freeBookingBottom =
      //   this.$refs.freeBookingRef.getBoundingClientRect().bottom;
      let trainingListBottom =
        this.$refs.trainingListRef.getBoundingClientRect().bottom;
      let freeBookingRefHeight = this.$refs.freeBookingRef.offsetHeight;
      let trainingListSortHeight = this.$refs.trainingListSortRef.offsetHeight;
      let condition1 =
        trainingListBottom - freeBookingRefHeight - trainingListSortHeight - 60;
      if (condition1 >= 0 && contentTopBottom <= 0) {
        this.freeBookingStyle = 1;
        return;
      } else {
        this.freeBookingStyle = 2;
      }

      // 默认计算触顶位置
      let containerTopRefHeight = this.$refs.containerTopRef.offsetHeight;
      this.topHeight =
        containerTopRefHeight + trainingListSortHeight + 60 + "px";
      // 计算触底位置
      // console.log(trainingListBottom);
      // console.log(freeBookingRefHeight);
      if (trainingListBottom - freeBookingRefHeight - 120 < 0) {
        // console.log("--计算触底位置-");
        let containerRefHeight = this.$refs.containerRef.offsetHeight;
        this.topHeight = containerRefHeight - freeBookingRefHeight - 30 + "px";
        // console.log(this.topHeight);
      }
    },
  },
  mounted() {
    this.getInternalTraininList();
    this.getInternalTraininTypeList();
    this.handleScrollx();
    this.getBanner();
    window.addEventListener("scroll", this.handleScrollx, true);
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
  created() {},
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>
<style scoped>
.container {
  width: 100%;
}
.container-top {
  background: #f8f8f8;
  background-repeat: no-repeat;
  background-position-x: center;
  background-image: var(--background);
  background-size: 1920px 350px;
  height: 350px;
}
.container-bottom {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 1060px;
  min-height: 400px;
  display: flex;
  margin: 0 auto;
}
.container-bottom .training-list {
  display: flex;
  flex-direction: column;
}
.training-list .training-list-sort {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  padding-top: 10px;
  cursor: pointer;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 20px;
  position: relative;
}
.training-list .training-list-sort ul {
  list-style: none;
}
.training-list .training-list-sort > ul > li {
  height: 30px;
  line-height: 30px;
  display: inline-block;
  font-size: 14px;
  color: #515255;
  text-align: left;
  width: 100px;
  border-radius: 4px 4px 0 0;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.training-list .training-list-sort .catagory {
  position: absolute;
  left: 100px;
  top: 54px;
  background: #fff;
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  z-index: 1000;
  box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
}
.training-list .training-list-sort .catagory div {
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  color: #515255;
  cursor: pointer;
}
.training-list .training-list-sort ul .select {
  background: #359ff8;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
}
.training-list-content {
  width: 100%;
  min-height: 600px;
  width: 746px;
}
.training-list-content .training-list-content-item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: flex-start;
  padding: 10px 0px;
  cursor: pointer;
  border-bottom: 1px solid #cccccc;
}
.training-list-content .training-list-content-item:hover .title {
  color: #359ff8;
}
.training-list-content-item .training-list-left {
  flex: 1;
  position: relative;
}
.training-list-content-item .training-list-left img {
  width: 100px;
  display: block;
  background: #efefef;
  border-radius: 3px;
  overflow: hidden;
  height: 100%;
  float: left;
}
.training-list-content-item .training-list-left p {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  position: absolute;
  width: 50px;
  left: 20px;
  top: 20px;
  text-shadow: 0 1px 2px rgb(0 0 0 / 50%);
  text-align: left;
}
.training-list-content-item .training-list-middle {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  flex: 4;
}
.training-list-content-item .training-list-middle > div {
  padding: 5px 0px;
}
.training-list-content-item .training-list-middle title {
  font-size: 18px;
  color: #222;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 700;
}
.training-list-content-item .training-list-middle .types {
  font-size: 14px;
  color: #666;
}
.training-list-content-item .training-list-middle .flex-row {
  display: flex;
  flex-direction: row;
}
.training-list-content-item .training-list-middle .duration {
  font-size: 14px;
  color: #666;
  padding-right: 10px;
}
.training-list-content-item .training-list-middle .method {
  font-size: 14px;
  color: #666;
}
.training-list-content-item .training-list-middle .crowds {
  font-size: 14px;
  color: #666;
}
.training-list-content-item .training-list-right {
  flex: 1;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.training-list-content-item .training-list-right div {
  padding: 5px 10px;
  color: #fff;
  background-color: #359ff8;
  border-radius: 25px;
}
/* 免费定制 */
.free-booking {
  left: auto;
  margin-top: 0px;
  width: 300px;

  /* bottom: 20px; */
  z-index: 0;
  margin-left: 756px;
  background: #fff;
  border: 2px solid #359ff8;
  border-radius: 3px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
}
.free-booking-1 {
  position: fixed;
  top: 80px;
}
.free-booking-2 {
  position: absolute;
  /* top: 750px; */
  /* position: relative;
    top: -2100px; */
}
.free-booking .free-booking-header {
  text-align: center;
}
.free-booking .free-booking-header .free-booking-dot {
  display: inline-block;
  background: #359ff8;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
  margin: 0 10px;
}
.free-booking .free-booking-header .free-booking-title {
  display: inline-block;
  font-weight: 700;
  font-size: 20px;
  color: #222;
  letter-spacing: 1px;
  height: 80px;
  line-height: 80px;
  vertical-align: middle;
}
.free-booking-item {
  position: relative;
  padding: 9px 25px 9px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
}
.free-booking-item .txt {
  display: inline;
  flex: 47;
  text-align: right;
  padding: 10px 5px 10px 0px;
}
.free-booking-item >>> div {
  flex: 100;
}

.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
/* el-select 样式 */
.free-booking-item >>> .el-input__inner,
.free-booking-item >>> .el-input__suffix {
  background-color: #f8f8f8;
}
.free-booking .free-booking-item2 >>> .el-input__inner {
  width: 170px !important;
}
.free-booking-item >>> .el-input__inner {
  border: none;
  width: 170px !important;
  background-color: #f8f8f8;
}
.free-booking-item .sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 105px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.request::before {
  content: "*";
  color: red;
  position: relative;
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.free-booking-item .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.free-booking-item .txt {
  padding-top: 10px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}

.free-booking-item-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.tool-button-primary button {
  color: #fff;
  font-weight: 700;
}
.tool-button button {
  outline: none;
  background: none;
  border: none;
  width: 250px;
  height: 100%;
  cursor: pointer;
}
.free-booking-itemimg {
  margin-top: 30px;
  width: 600px;
}
.element-row {
  flex-flow: row wrap;
}
.tool-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  background: #222;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
.pagination {
  margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/internalTraining/internalTrainingList.vue